import * as d3 from 'd3';
import { workHourColorScale, gdpGrowthColorScale } from './colorScale';

let data = null;

const $figWorkHour = d3.select('#work-hour');
const $figGdpGrowth = d3.select('#gdp-growth');

function updateChoice($choice, { field, colorScale }) {
	const $choiceText = $choice.select('.waffle--choice__text');
	$choiceText.text(d => d.key);

	const $percentage = $choice.select('.waffle--choice__percentage');
	$percentage.text(d => d3.format('.2%')(d.percentage));

	const $count = $choice.select('.waffle--choice__count');
	$count.text(d => d.values.length + ' คน');

	const $cellContainer = $choice.select('.waffle--cell-container');
	$cellContainer
		.selectAll('.waffle--cell-container__cell')
		.data(d => d.values)
		.enter()
		.append('div')
		.attr('class', 'waffle--cell-container__cell')
		.style('background-color', d => colorScale(d[field]));
}

function setupChart() {
	let gdpGrowthData = d3
		.nest()
		.key(d => d.gdp_growth)
		.entries(data);

	gdpGrowthData = gdpGrowthData
		.map(({ key, values }) => {
			const percentage = values.length / data.length;
			return { key, values, percentage };
		})
		.sort(function(a, b) {
			if (a.key < b.key) {
				return -1;
			}
			if (a.key > b.key) {
				return 1;
			}
			return 0;
		});

	const $waffleChoiceGdpGrowth = $figGdpGrowth
		.selectAll('.waffle--choice')
		.data(gdpGrowthData);
	$waffleChoiceGdpGrowth.call(updateChoice, {
		colorScale: gdpGrowthColorScale,
		field: 'gdp_growth'
	});

	let workHourData = d3
		.nest()
		.key(d => d.work_hour)
		.entries(data);

	workHourData = workHourData
		.map(({ key, values }) => {
			const percentage = values.length / data.length;
			values = values.sort(function(a, b) {
				if (a.gdp_growth < b.gdp_growth) {
					return -1;
				}
				if (a.gdp_growth > b.gdp_growth) {
					return 1;
				}
				return 0;
			});
			return { key, values, percentage };
		})
		.sort(function(a, b) {
			if (a.key < b.key) {
				return -1;
			}
			if (a.key > b.key) {
				return 1;
			}
			return 0;
		});

	const $waffleChoiceWorkHour = $figWorkHour
		.selectAll('.waffle--choice')
		.data(workHourData);
	$waffleChoiceWorkHour.call(updateChoice, {
		colorScale: workHourColorScale,
		field: 'work_hour'
	});

	// const workHourTooltipData = workHourData.map(({ key, values }) => {
	// 	let gdpGroup = d3
	// 		.nest()
	// 		.key(d => d.gdp_growth)
	// 		.entries(values);
	// 	let res = gdpGroup.map(({ key: choice, values: answer }) => {
	// 		const percentage = answer.length / values.length;
	// 		return { choice, percentage };
	// 	});
	// 	return res;
	// });

	// const $workHourTooltip = $waffleChoiceWorkHour
	// 	.select('.waffle--choice__tooltip')
	// 	.data(workHourTooltipData)
	// 	.selectAll('.waffle--choice__tooltip-choice')
	// 	.data(d => d);

	// const $tooltipChoice = $workHourTooltip
	// 	.text(d => `${d.choice} ${d3.format('.2%')(d.percentage)}`)
	// 	.style('color', d => gdpGrowthColorScale[d.choice]);
}

async function init(surveyData) {
	data = surveyData;
	setupChart();
}

export { init as waffleInit };
